import {
  EuiButtonIcon,
  EuiContextMenuItem,
  EuiContextMenuPanel,
  EuiPopover,
} from "@inscopix/ideas-eui";
import { useTenantContext } from "providers/TenantProvider/TenantProvider";
import { useState } from "react";
import { ContainerImageStatus } from "types/constants";

interface ButtonContainerActionsProps {
  tenantId?: number;
  onDelete: () => void;
  onDownload: () => void;
  containerImageStatus: ContainerImageStatus;
}

export const ButtonContainerActions = ({
  tenantId,
  onDelete,
  onDownload,
  containerImageStatus,
}: ButtonContainerActionsProps) => {
  const currentTenantId = useTenantContext((s) => s.currentTenant.id);
  const [isPopoverOpen, setIsPopoverOpen] = useState(false);

  return (
    <EuiPopover
      isOpen={isPopoverOpen}
      closePopover={() => setIsPopoverOpen(false)}
      button={
        <EuiButtonIcon
          aria-label="Edit container"
          iconType="gear"
          color="text"
          onClick={() => setIsPopoverOpen((isOpen) => !isOpen)}
        />
      }
    >
      <EuiContextMenuPanel
        size="s"
        items={[
          <EuiContextMenuItem
            key="download"
            icon="download"
            onClick={() => {
              setIsPopoverOpen(false);
              onDownload();
            }}
            color="primary"
            disabled={containerImageStatus === ContainerImageStatus.UPLOADING}
          >
            Download
          </EuiContextMenuItem>,
          ...(tenantId === currentTenantId
            ? [
                <EuiContextMenuItem
                  key="delete"
                  icon="trash"
                  onClick={() => {
                    setIsPopoverOpen(false);
                    onDelete();
                  }}
                  color="danger"
                >
                  Delete
                </EuiContextMenuItem>,
              ]
            : []),
        ]}
      />
    </EuiPopover>
  );
};
